/** Azerbaijan national mobile number after the +994 country code. */

const AZ_MOBILE_PREFIXES = ['10', '50', '51', '55', '60', '70', '77', '99'] as const;

export function digitsOnly(raw: string): string {
  return raw.replace(/\D/g, '');
}

export function nationalDigitsFromInput(raw: string): string {
  let digits = digitsOnly(raw);
  if (digits.startsWith('994')) digits = digits.slice(3);
  return digits.slice(0, 9);
}

export function formatAzNational(digits: string): string {
  const value = nationalDigitsFromInput(digits);
  if (value.length <= 2) return value;
  if (value.length <= 5) return `${value.slice(0, 2)} ${value.slice(2)}`;
  if (value.length <= 7) return `${value.slice(0, 2)} ${value.slice(2, 5)} ${value.slice(5)}`;
  return `${value.slice(0, 2)} ${value.slice(2, 5)} ${value.slice(5, 7)} ${value.slice(7)}`;
}

export function isValidAzMobile(digits: string): boolean {
  const value = nationalDigitsFromInput(digits);
  if (value.length !== 9) return false;
  return (AZ_MOBILE_PREFIXES as readonly string[]).includes(value.slice(0, 2));
}

export function toE164(digits: string): string | null {
  const value = nationalDigitsFromInput(digits);
  if (!isValidAzMobile(value)) return null;
  return `+994${value}`;
}
